import {combineReducers} from "redux";

// import reducers
import general from './general';
import utils from './utils';
import blog from './blog';


export default combineReducers({
    general,
    utils,
    blog,
});
